<script>
  import { diff } from 'mapbox-gl-style-diff';
  import DiffEntry from './DiffEntry.svelte';
  import DiffWithinLayer from './DiffWithinLayer.svelte';

  export let style0;
  export let style1;

  let diffOutput = {};

  const isValidStyle = style => style && Object.keys(style);

  const typeToVerb = {
    add: 'added',
    move: 'moved',
    remove: 'removed'
  };

  const computeDiff = () => {
    if (isValidStyle(style0) && isValidStyle(style1)) {
      diffOutput = diff(style0, style1);
    } else {
      diffOutput = {};
    }
  };

  $: style0 && style1 && computeDiff();

  $: rootProperties = JSON.parse(
    JSON.stringify({
      glyphs: diffOutput?.glyphs,
      sprite: diffOutput?.sprite
    })
  );
</script>

<section class="diff-section">
  <button on:click={computeDiff}> Compute Diff </button>

  {#if diffOutput.glyphs || diffOutput?.sprite}
    <section>
      <h2>Root</h2>
      <DiffWithinLayer properties={rootProperties} />
    </section>
  {/if}

  {#if diffOutput.sources}
    <section>
      <h2>Sources</h2>
      {#each Object.entries(diffOutput.sources) as [source, status]}
        <DiffEntry name={source} {status}>
          {typeToVerb[status]}
        </DiffEntry>
      {/each}
    </section>
  {/if}

  {#if diffOutput.layers}
    <section>
      <h2>Layers</h2>
      {#each Object.entries(diffOutput.layers) as [layer, details]}
        <DiffEntry name={layer} status={details.type}>
          {typeToVerb[details.type]}
          {#if details.type === 'add' || details.type === 'move'}
            under <em>{details.layerAbove}</em>
          {/if}
        </DiffEntry>
      {/each}
    </section>
  {/if}

  {#if diffOutput.layerProps}
    <section>
      <h2>Within layers</h2>
      {#each Object.entries(diffOutput.layerProps) as [layer, properties]}
        <DiffWithinLayer {layer} {properties} />
      {/each}
    </section>
  {/if}
</section>

<style>
  h2 {
    font-size: 1.2em;
    margin-top: 0;
  }

  .diff-section {
    flex-grow: 1;
    padding: 1em;
    overflow-y: auto;
  }
</style>
